"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _A = _interopRequireDefault(require("../A"));

var _excluded = ["copyright", "icon", "variant", "year", "url"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var breakpoints = _ref.breakpoints;
  return {
    root: {},
    organization: _defineProperty({
      marginBottom: "2.243125rem"
    }, breakpoints.up("md"), {
      marginBottom: "4.305625rem"
    }),
    organizationLogo: _defineProperty({
      width: "13.875rem",
      height: "auto"
    }, breakpoints.up("md"), {
      width: "18.3175rem"
    }),
    copyright: _defineProperty({
      marginTop: "1.618125rem",
      order: 3,
      textAlign: "center"
    }, breakpoints.up("md"), {
      marginTop: 0,
      order: 2
    }),
    copyrightLogo: {
      marginLeft: "0.80375rem",
      verticalAlign: "middle"
    },
    text: {}
  };
});

function Copyright(_ref2) {
  var copyright = _ref2.copyright,
      icon = _ref2.icon,
      variant = _ref2.variant,
      year = _ref2.year,
      url = _ref2.url,
      props = _objectWithoutProperties(_ref2, _excluded);

  var classes = useStyles(props);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (copyright || icon || year) && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(classes.copyright, classes.root)
  }, copyright && /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: variant,
    className: (0, _clsx["default"])(classes.text, classes.copyrightText)
  }, copyright), icon && /*#__PURE__*/_react["default"].createElement(_A["default"], {
    href: url,
    className: "copyrightLogo"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: icon,
    alt: copyright,
    className: classes.copyrightIcon
  })), year && /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: variant,
    className: (0, _clsx["default"])(classes.text, classes.copyrightYear)
  }, year)));
}

Copyright.propTypes = {
  copyright: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  variant: _propTypes["default"].string,
  url: _propTypes["default"].string,
  year: _propTypes["default"].string
};
Copyright.defaultProps = {
  copyright: "Copyright",
  icon: undefined,
  year: undefined,
  variant: "body1",
  url: ""
};
var _default = Copyright;
exports["default"] = _default;